import { Injectable } from '@angular/core'
import { environment } from '../../environments/environment'

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  private originalConsole = {
    log: console.log,
    error: console.error,
    warn: console.warn,
    info: console.info,
    debug: console.debug,
  }

  constructor() {
    this.setupConsoleOverrides()
  }

  /**
   * Log a debug message (only shown when logLevel is 'debug')
   */
  debug(...args: any[]): void {
    if (environment.logLevel === 'debug') {
      this.originalConsole.log(...args)
    }
  }

  /**
   * Log an error message (shown when logLevel is 'error' or 'debug')
   */
  error(...args: any[]): void {
    if (environment.logLevel === 'error' || environment.logLevel === 'debug') {
      this.originalConsole.error(...args)
    }
  }

  /**
   * Log a warning message (shown when logLevel is 'debug')
   */
  warn(...args: any[]): void {
    if (environment.logLevel === 'debug') {
      this.originalConsole.warn(...args)
    }
  }

  /**
   * Override native console methods to use our logLevel-aware implementation
   */
  private setupConsoleOverrides(): void {
    // Override console.log
    console.log = (...args: any[]) => {
      if (environment.logLevel === 'debug') {
        this.originalConsole.log.apply(console, args)
      }
    }

    // Override console.warn - only show in debug mode
    console.warn = (...args: any[]) => {
      if (environment.logLevel === 'debug') {
        this.originalConsole.warn.apply(console, args)
      }
    }

    // Override console.info
    console.info = (...args: any[]) => {
      if (environment.logLevel === 'debug') {
        this.originalConsole.info.apply(console, args)
      }
    }

    // Override console.debug
    console.debug = (...args: any[]) => {
      if (environment.logLevel === 'debug') {
        this.originalConsole.debug.apply(console, args)
      }
    }

    // Keep console.error as is unless logLevel is 'none'
    console.error = (...args: any[]) => {
      if (environment.logLevel !== 'none') {
        this.originalConsole.error.apply(console, args)
      }
    }
  }
}
